import React, { useEffect, useState } from "react";
import { ReactComponent as Company1 } from "../../assets/Company/Company1.svg";
import { ReactComponent as Company2 } from "../../assets/Company/Company2.svg";
import { ReactComponent as Company3 } from "../../assets/Company/Company3.svg";
import { ReactComponent as Company4 } from "../../assets/Company/Company4.svg";
import { ReactComponent as Company5 } from "../../assets/Company/Company5.svg";
import Service1 from "../../assets/services/service1-Photoroom.png";
import Service2 from "../../assets/services/service2-Photoroom.png";
import Service3 from "../../assets/services/service3-Photoroom.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Services = ({ windowSize }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null; // Prevent rendering until mounted
  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div>
      <div className="w-full bg-white rounded-4xl mt-5 p-4 shadow-md space-y-5">
        <div className="text-center">
          <p className=" tex-[#2D3643] text-xl ">
           Built for immigration experts, inspired by the tools they trust
          </p>
        </div>
        {windowSize.width > 1024 ? (
          <div className="container mx-auto flex gap-4 mt-4 justify-evenly">
            <Company1 />
            <Company2 />
            <Company3 />
            <Company4 />
            <Company5 />
          </div>
        ) : (
          <div className="container mx-auto">
            <Slider {...settings}>
              <Company1 />
              <Company2 />
              <Company3 />
              <Company4 />
              <Company5 />
            </Slider>
          </div>
        )}
      </div>

      <div className="mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <div className="bg-primary rounded-4xl p-8 shadow-md relative overflow-hidden">
          <div className="mb-4">
            <img
              src={Service1}
              alt="ATA Member"
              className="absolute rotate-3  top-[-142.28px] right-[-140px]  h-[441px] w-[441px] select-none"
            />
          </div>
          <div className="space-y-4 md:pt-40 pt-14 relative z-10">
            <h3 className="text-2xl font-secondary font-medium text-white">
              ATA Corporate Member
            </h3>
            <p className="text-5xl font-medium text-white font-secondary">
              #273062
            </p>
            <hr className="border-t border-white opacity-30 my-3" />

            <p className="text-base text-white">
              As an ATA Corporate Member, we uphold top standards of quality and
              professionalism.
            </p>
          </div>
        </div>

        <div className="bg-[#F46350] rounded-4xl p-8 shadow-md relative overflow-hidden">
          <div className="mb-4">
            <img
              src={Service2}
              alt="ATA Member"
              className="absolute rotate-[15.5deg] top-[-64px] right-[-80px] h-[300px] w-[330px] select-none "
            />
          </div>
          <div className="space-y-4 md:pt-40 pt-14 relative z-10">
            <h3 className="text-2xl font-secondary font-medium text-white">
              USCIS Acceptance{" "}
            </h3>
            <p className="text-5xl font-medium text-white font-secondary">
              100%
            </p>
            <hr className="border-t border-white opacity-30 my-3" />

            <p className="text-base text-white">
              Guaranteed acceptance by USCIS, courts, and other official
              institutions.
            </p>
          </div>
        </div>

        <div className="bg-[#7245ED] rounded-4xl p-8 shadow-md relative overflow-hidden">
          <div className="mb-4">
            <img
              src={Service3}
              alt="ATA Member"
              className="absolute rotate-[15deg]  top-[-115px] right-[-115px]  h-[375px] w-[375px] select-none"
            />
          </div>
          <div className="space-y-4 md:pt-40 pt-14 relative z-10">
            <h3 className="text-2xl font-secondary font-medium text-white">
              Trusted by{" "}
            </h3>
            <p className="text-5xl font-medium text-white font-secondary">
              1,250 + Firms
            </p>
            <hr className="border-t border-white opacity-30 my-3" />

            <p className="text-base text-white">
              Preferred by over 1250 law firms for legal and immigration
              translations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
